/* GENERATED FILE */
import React, { useContext, useMemo } from 'react';
import { IconProps, IconContext } from '../lib';

import bold from '../bold/LinkSimpleHorizontalBreak';
import duotone from '../duotone/LinkSimpleHorizontalBreak';
import fill from '../fill/LinkSimpleHorizontalBreak';
import light from '../light/LinkSimpleHorizontalBreak';
import regular from '../regular/LinkSimpleHorizontalBreak';
import thin from '../thin/LinkSimpleHorizontalBreak';

function LinkSimpleHorizontalBreak({ weight, color, size, style }: IconProps) {
  const {
    color: contextColor = '#000',
    size: contextSize = 24,
    weight: contextWeight = 'regular',
    style: contextStyle,
  } = useContext(IconContext);

  const IconComponent = useMemo(() => {
    const iconWeight = weight ?? contextWeight;

    const weightMap = {
      bold,
      duotone,
      fill,
      light,
      regular,
      thin,
    };

    return weightMap[iconWeight];
  }, [weight, contextWeight]);

  return (
    <IconComponent
      color={color ?? contextColor}
      size={size ?? contextSize}
      style={{
        ...contextStyle,
        ...style,
      }}
    />
  );
}

export default LinkSimpleHorizontalBreak;
